import React from 'react'
import './index.less'
import cdn from 'src/helper/cdn'
import { isRtl } from 'src/helper/tool'


export default class extends React.Component {

  constructor(props) {
    super(props)
  }

  componentDidMount() {
    // console.log('componentDidMount')
  }

  componentWillReceiveProps(e) {
    // console.log('componentWillReceiveProps')
  }

  componentWillReceiveProps(e) {
    // console.log('componentWillReceiveProps')
  }

  render() {
    let { lang, nav, language, now } = this.props
    return (
      <div className={`nav navbg${nav} ${isRtl(language) && 'arlang'}`}>
        <div className={`navitem ${nav == 1 && "active"}`} onClick={this.props.changeNav.bind(this, 1)}>{lang.nav1}</div>
        <div className={`navitem ${nav == 2 && "active"}`} onClick={this.props.changeNav.bind(this, 2)}>{lang.nav2}</div>
        <div className={`navitem ${nav == 3 && "active"}`} onClick={this.props.changeNav.bind(this, 3)}>{lang.nav3}</div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// src/pages/app/roomsupport/Nav/index.js